export function isValidCsatResponse(response) {
  return typeof response.score === 'number' && typeof response.canContact === 'boolean';
}